module.exports = __webpack_public_path__ + "img/BlinkArt_Sword6_Red.809ea63f.png";